module.exports = __webpack_public_path__ + "img/2603.554652b.svg";